export default "__VITE_ASSET__BOTY_nbH__"